import { META_PIXEL_ACTION_SOURCE, setCookieData } from '@repo/common-utils';
import { atom, useAtom } from 'jotai';

import { BROWSER_TYPE, PARTNER_APP_LIST, WORKING_PLATFORM_KEY, WORKING_PLATFORM_TYPE } from '../constants';
import { BrowserType, WorkingPlatform, WorkingPlatformType } from '../types';
import { getClientWorkingPlatform } from '../utils/platform-detector-client';

const workingPlatform = getClientWorkingPlatform();
export const workingPlatformAtom = atom<WorkingPlatform>(workingPlatform);
export const workingPlatformTypeAtom = atom<WorkingPlatformType>(WORKING_PLATFORM_TYPE[workingPlatform] || 'web');
export const browserTypeAtom = atom<BrowserType>(BROWSER_TYPE[workingPlatform] || 'system');
export const isPartnerPlatformAtom = atom<boolean>(PARTNER_APP_LIST.includes(workingPlatform));

export const useWorkingPlatform = () => {
  const [workingPlatform, setWorkingPlatform] = useAtom(workingPlatformAtom);
  const [workingPlatformType, setWorkingPlatformType] = useAtom(workingPlatformTypeAtom);
  const [browserType, setBrowserType] = useAtom(browserTypeAtom);
  const [isPartnerPlatform, setIsPartnerPlatform] = useAtom(isPartnerPlatformAtom);

  const updateWorkingPlatform = (newWorkingPlatform: WorkingPlatform) => {
    setCookieData(WORKING_PLATFORM_KEY, newWorkingPlatform);
    if (workingPlatform === newWorkingPlatform) return;

    const isPartnerApp = PARTNER_APP_LIST.includes(newWorkingPlatform);
    setWorkingPlatform(newWorkingPlatform);
    setWorkingPlatformType(WORKING_PLATFORM_TYPE[newWorkingPlatform] || 'web');
    setBrowserType(BROWSER_TYPE[newWorkingPlatform] || 'system');
    setIsPartnerPlatform(isPartnerApp);

    setCookieData(META_PIXEL_ACTION_SOURCE, isPartnerApp ? 'app' : 'website');
  };

  return { workingPlatform, updateWorkingPlatform, workingPlatformType, browserType, isPartnerPlatform };
};
